import { render } from "./DashboardHeader.vue?vue&type=template&id=ba762f48&scoped=true&ts=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts"

import "./DashboardHeader.vue?vue&type=style&index=0&id=ba762f48&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba762f48"]])

export default __exports__